import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import Navbar from './components/Navbar';
import SectionBackdrop from './components/SectionBackdrop';
import styled from 'styled-components';

const AboutPage = lazy(() => import('./components/AboutPage'));
const CareersPage = lazy(() => import('./components/CareersPage'));
const ContactUs = lazy(() => import('./components/ContactUs'));

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #000;
  }

  @media (max-width: 768px) {
    * {
      scroll-behavior: auto;
    }
  }
`;

const HomeSections = styled.div`
  position: relative;
`;

const HomeContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
`;

const HomePage = () => (
  <>
    <HeroSection />
    <HomeSections>
      <SectionBackdrop />
      <HomeContent>
        <ProductsSection sharedBackdrop />
        <Suspense fallback={null}>
          <AboutPage embedded />
          <ContactUs />
        </Suspense>
      </HomeContent>
    </HomeSections>
  </>
);

function App() {
  return (
    <Router>
      <GlobalStyle />
      <Navbar />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
